import { useMutation, useQueryClient } from '@tanstack/react-query';
import {
  updateHealthMetrics,
  healthMetricsV3Path,
} from '@leagueplatform/dashboard-api';

export const usePatchHealthMetrics = () => {
  const queryClient = useQueryClient();
  const mutation = useMutation(updateHealthMetrics, {
    onSuccess: () => {
      queryClient.invalidateQueries([healthMetricsV3Path]);
    },
  });

  return mutation;
};
